export default __webpack_public_path__ + "static/media/Elipse1.5d751d6e.svg";